import styled from 'styled-components';
export const Group = styled.ul `
  @apply inline-flex justify-center p-0 items-center h-full rounded min-h-6 cursor-pointer;

  border: ${(props) => (props.borderless ? 'none' : '1px solid var(--border-color);')}
  background-color: var(--bg-color-1);
  --ggs: 0.75;

  li[data-role='icon-group-item']::after {
    @apply absolute w-px r-0 h-4;

    content: '';
    background-color: rgba(0, 0, 0, 0.05);
    top: 50%;
    transform: translateY(-50%);
  }

  li[data-role='icon-group-item']:last-child::after {
    @apply hidden;
  }
`;
export const Item = styled.li `
  @apply h-6 min-w-8 rounded-sm flex items-center justify-center relative;
  color: ${(props) => props.color || 'var(--text-color-2)'};
  background-color: ${(props) => (props.isSelected ? 'rgba(0, 0, 0, 0.05)' : 'transparent')};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
